import { z } from 'zod';

export const newPartnerFormSchema = z.object({
  contact: z.object({
    email: z.string().email().toLowerCase(),
    title: z.string().trim().min(1),
    lastName: z.string().trim().min(1).max(300),
    firstName: z.string().trim().min(1).max(300),
    phone: z
      .string()
      .trim()
      .optional()
      .refine(value => {
        if (!value) return true;

        const maskRegex = /^\(\d{3}\) \d{3}-\d{4}$/;

        return (maskRegex.test(value ?? ''), { message: 'Phone must be in format (999) 999-9999' });
      }),
  }),
});
